// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabHead":"tabHead-3t7lilqi","tabHeadItem":"tabHeadItem-3DHn3h-B","current":"current-3P2PwGU3","fix":"fix-20k44Vqw"};